module.exports = __webpack_public_path__ + "static/img/envelope01khm.812d11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope01khm.png
// module id = QMlf
// module chunks = 1